import { UserType } from "@common/types/user";
import { useUserStatus } from "./useUserStatus";

export function useIsDemoUser(): boolean {
    const { data: userStatus } = useUserStatus();

    return userStatus?.user.type === UserType.DEMO;
}
